import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import BreadProduct from 'models/BreadProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { breadTypeOptions, packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const BreadPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, BreadType, BreadSize } = current
      setPackaging({
        category,
        subCategory,
        BreadType: {
          value: BreadType || '',
          label: BreadType.length > 0 ? BreadType : 'Bread Type',
        },
        BreadSize,
      })
    } else if (!updating) {
      setCurrent(BreadProduct)
    }
    // eslint-disable-next-line
    }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Bread Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={breadTypeOptions}
          name="BreadType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Bread Type'}
          onChange={([selected]) => {
            setSelect(selected, 'BreadType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BreadType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
        </FormGroup>
        {/* <Controller
          as={Input}
          name="BreadSize"
          placeholder={'Size'}
          control={methods.control}
          rules={{ required: true, maxLength: 15 }}
          onChange={([event]) => {
            onChange(event)
            return event
          }}
        />
        <p className={'text-danger'}>
          {methods.errors.BreadSize &&
            methods.errors.BreadSize.type === 'required' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Bread size is required.
              </Alert>
            )}
          {methods.errors.BreadSize &&
            methods.errors.BreadSize.type === 'maxLength' && (
              <Alert color="danger" className={'mt-3'}>
                ⚠ Bread size exceeds 15 characters.
              </Alert>
            )}
        </p> */}
        <Input defaultValue={'16 ounces only'} disabled />
        <br />
      </Col>
    </Row>
  )
}

export default BreadPackage
